import { pick } from 'lodash';
import { API } from '@shared/types/api';
import { omitTypeName } from '@shared/util/omitTypeName';

export type EditableViewTemplate = Pick<
  API.ViewTemplateFragment,
  'componentsViewOptions' | 'defaultHiddenLabels' | 'collectionCriteria'
>;

export function getEditableViewTemplate(
  viewTemplate: API.ViewTemplateFragment,
): EditableViewTemplate {
  const viewTemplateWithoutTypeName = omitTypeName(viewTemplate);
  return pick(
    viewTemplateWithoutTypeName,
    'name',
    'subtype',
    'calendarDateComponentId',
    'checklistTagComponentId',
    'componentsViewOptions',
    'defaultHiddenLabels',
    'collectionCriteria',
  );
}

export function getViewTemplateStorageKey(id: string): string {
  return `viewTemplate-${id}`;
}
